<template>
  <div
    class="text-input"
    :class="{ accepted: accepted, error: error, hasValue: hasValue }"
  >
    <span class="label label-number">{{ placeholder }}</span>
    <div class="input-field">
      <input
        type="number"
        pattern="\d*"
        numeric
        digitOnly
        inputmode="numeric"
        :value="modelValue"
        @input="updateValue"
        onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
      />
      <fa
        icon="check"
        class="checkmark"
      />
      <fa
        icon="exclamation"
        class="exclamation"
      />
    </div>
    <div>
      <small class="hint">Bitte nur Zahlen verwenden</small>
    </div>
    <small class="error-msg">{{ errorMsg }}</small>
  </div>
</template>
<script>
export default {
  name: "text-field",
  props: {
    modelValue: String,
    placeholder: String,
    state: String,
  },

  computed: {
    accepted() {
      return this.state && this.state.startsWith("ACCEPTED");
    },
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
    hasValue() {
      return this.modelValue != null && this.modelValue.length > 0;
    },
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>
